module.exports = __webpack_public_path__ + "static/media/99gal11.47ebc87a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal11.gif
// module id = 411
// module chunks = 0